
export default {
  props: {
    states: {
      type: Object,
      default: () => ({}),
      required: true
    }
  }
}
